<template>
  <section 
    data-component="hcAboutMemorable"
    :data-visibility="visibility"
    class="about-subsection"
  >
    <template v-if="visibility === 'mobile'">
      <div class="graphic">
        <div class="quadrant-l">
          <div class="subquadrant-t">
            <div class="placeholder"></div>
            <img src="@/content/about/images/eyeball.svg" alt="">
          </div>
          <div class="subquadrant-bl">
            <div class="placeholder"></div>
            <img src="@/content/about/images/finger.svg" alt="">
          </div>
          <div class="subquadrant-br">
            <div class="placeholder"></div>
          </div>
        </div>
        <div class="quadrant-r">
          <div class="subquadrant-t">
            <div class="placeholder"></div>
            <img src="@/content/about/images/halfcircles_left.svg" alt="">
          </div>
          <div class="subquadrant-bl">
            <div class="placeholder"></div>
            <img src="@/content/about/images/crystal.svg" alt="">
          </div>
          <div class="subquadrant-br">
            <div class="placeholder"></div>
            <img src="@/content/about/images/radial.svg" alt="">
          </div>
        </div>
      </div>
      <div class="content">
        <div class="content__container">
          <span>02</span>
          <h1 class="h1">
            Make it
            <br />
            Memorable
          </h1>
          <p>
            We change how brands think of their users and how users think of brands. Through a design process developed over years of experience across industries, we define, design, and develop moments that make a difference in brand experiences. We create with heart and hustle to think big, take risks, and design game-changing products that drive innovation forward. 
          </p>
          <div class="headline">
            <span data-ornament="rectangle" />
            <h2 class="h2">
              Services
            </h2>
          </div>
          <ul class="services">
            <li class="service">Visual Design</li>
            <li class="service">Roles & Task Flows</li>
            <li class="service">Interaction Design</li>
            <li class="service">Usability Testing</li>
            <li class="service">UX Strategy</li>
            <li class="service">Data Visualization</li>
          </ul>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="content__anchor" id="hcAboutMemorable"></div>
      <ScrollItem :id="`aboutMemorable_component_top`">
        <div data-anchor="aboutMemorable_component_top"></div>
      </ScrollItem>
      <div class="content" :class="contentFixed">
        <div class="content__container" :style="contentOpacity">
          <span class="tab-number">02</span>
          <h1 class="h1">
            Make it
            <br />
            Memorable
          </h1>
          <p>
            We change how brands think of their users and how users think of brands. Through a design process developed over years of experience across industries, we define, design, and develop moments that make a difference in brand experiences. We create with heart and hustle to think big, take risks, and design game-changing products that drive innovation forward. 
          </p>
          <div class="headline">
            <span data-ornament="rectangle" />
            <h2 class="h2">
              Services
            </h2>
          </div>
          <ul class="services">
            <li class="service">Visual Design</li>
            <li class="service">Roles & Task Flows</li>
            <li class="service">Interaction Design</li>
            <li class="service">Usability Testing</li>
            <li class="service">UX Strategy</li>
            <li class="service">Data Visualization</li>
          </ul>
        </div>
      </div>
      <div class="graphic" :class="graphicFixed" v-if="visibility === 'compact'">
        <div class="quadrant-1">
          <div class="placeholder blue"></div>
          <img src="@/content/about/images/eyeball.svg" alt="">
        </div>
        <div class="quadrant-2">
          <div class="subquadrant-l">
            <div class="placeholder yellow"></div>
            <img src="@/content/about/images/radial.svg" alt="">
          </div>
          <div class="subquadrant-r">
            <div class="placeholder black"></div>
          </div>
        </div>
        <div class="quadrant-3">
          <div class="placeholder white"></div>
          <img src="@/content/about/images/halfcircles.svg" alt="">
        </div>
        <div class="quadrant-4">
          <div class="placeholder blue"></div>
          <img src="@/content/about/images/finger.svg" alt="">
        </div>
      </div>
      <div class="graphic" :class="graphicFixed" v-if="visibility === 'full'">
        <div class="quadrant-tl">
          <div class="placeholder black"></div>
          <img src="@/content/about/images/sunburst.svg" alt="">
        </div>
        <div class="quadrant-tr">
          <div class="subquadrant-t">
            <div class="placeholder blue"></div>
            <img src="@/content/about/images/eyeball.svg" alt="">
          </div>
          <div class="subquadrant-ml">
            <div class="placeholder yellow"></div>
            <img src="@/content/about/images/radial.svg" alt="">
          </div>
          <div class="subquadrant-mr">
            <div class="placeholder black"></div>
          </div>
          <div class="subquadrant-b">
            <div class="placeholder white"></div>
            <img src="@/content/about/images/halfcircles.svg" alt="">
          </div>
        </div>
        <div class="quadrant-bl">
          <div class="placeholder yellow"></div>
          <img src="@/content/about/images/finger.svg" alt="">
        </div>
        <div class="quadrant-br">
          <div class="placeholder blue"></div>
          <img src="@/content/about/images/crystal.svg" alt="">
        </div>
      </div>
    </template>
  </section>
</template>

<script>
export default {
  name: 'component_hcAboutMemorable',
  props: ['scrollState', 'visibility', 'percentScrolled'],
  computed: {
    contentOpacity: function() {
      let opacity = 0;
      let pointerEvents = 'none';

      const percentScrolled = this.percentScrolled;

      if (percentScrolled < 200) {
        opacity = 0;
        pointerEvents = 'none';
      } else if (percentScrolled < 225) {
        opacity = (percentScrolled - 200) / 25;
        pointerEvents = 'auto';
      } else if (percentScrolled < 250) {
        opacity = 1;
        pointerEvents = 'auto';
      } else if (percentScrolled < 312.5) {
        opacity = 1 - ((percentScrolled - 250) / 62.5);
        pointerEvents = 'none';
      }

      return {
        opacity: opacity,
        pointerEvents: pointerEvents,
      };
    },
    graphicFixed: function () {
      const classes = {
        following: false,
        'fixed--bottom': false,
      };

      const top = this.scrollState.aboutMemorable_component_top;
      const bot = this.scrollState.bottomOfAboutContent;

      if (!top || !bot) {
        return classes;
      }

      if (top.isAboveViewport && bot.isBelowViewport) {
        classes.following = true;
      } else if (top.isAboveViewport && !bot.isBelowViewport) {
        classes['fixed--bottom'] = true;
      }

      return classes;
    },
    contentFixed: function() {
      const classes = {
        fixed: false,
        'fixed--bottom': false,
      };

      const top = this.scrollState.topOfAboutContent;
      const bot = this.scrollState.bottomOfAboutContent;

      if (!top || !bot) {
        return classes;
      }

      if (top.isAboveViewport && bot.isBelowViewport) {
        classes.fixed = true;
      } else if (top.isAboveViewport && !bot.isBelowViewport) {
        classes['fixed--bottom'] = true;
      }

      return classes;
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';

[data-component="hcAboutMemorable"] {
  [data-anchor="aboutMemorable_component_top"] {
    position: absolute;
    top: 0;
  }

  &[data-visibility="mobile"] {
    .graphic {
      .quadrant-l {
        grid-column: 1 / span 1;

        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;

        .subquadrant-t {
          grid-column: 1 / span 2;
          grid-row:  1 / span 1;
          @include imageRatio(.5);
        }

        .subquadrant-bl {
          grid-column: 1 / span 1;
          grid-row: 2 / span 1;
        }

        .subquadrant-br {
          grid-column: 2 / span 1;
          grid-row: 2 / span 1;
        }
      }

      .quadrant-r {
        grid-column: 2 / span 1;

        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;

        .subquadrant-t {
          grid-column: 1 / span 2;
          grid-row: 1 / span 1;
        }

        .subquadrant-bl {
          grid-column: 1 / span 1;
          grid-row: 2 / span 1;
        }

        .subquadrant-br {
          grid-column: 2 / span 1;
          grid-row: 2 / span 1;
        }
      }
    }
  }

  &[data-visibility="compact"] {
    height: 125vh;

    .graphic {
      .quadrant-1 {
        grid-column: 1 / span 2;
        grid-row: 1 / span 1;
      }

      .quadrant-2 {
        grid-column: 1 / span 2;
        grid-row: 2 / span 1;

        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows:  1fr;

        .subquadrant-l {
          grid-column: 1 / span 1;
          grid-row: 1 / span 1;
        }

        .subquadrant-r {
          grid-column: 2 / span 1;
          grid-row: 1 / span 1;
        }
      }

      .quadrant-3 {
        grid-column: 1 / span 2;
        grid-row: 3 / span 1;
      }

      .quadrant-4 {
        grid-column: 1 / span 2;
        grid-row: 4 / span 2;
      }
    }
  }

  &[data-visibility="full"] {
    height: 125vh;
    
    .graphic {
      .quadrant-tl {
        @include imageRatio(1.5);
        grid-column: 1 / span 1;
        grid-row: 1 / span 3;
      }

      .quadrant-tr {
        grid-column: 2 / span 1;
        grid-row: 1 / span 3;

        display: grid;
        grid-template-rows: repeat(3, 1fr);
        grid-template-columns: repeat(2, 1fr);

        .subquadrant-t {
          grid-row: 1 / span 1;
          grid-column: 1 / -1;
        }

        .subquadrant-ml {
          grid-row: 2 / span 1;
          grid-column: 1 / span 1;
        }

        .subquadrant-mr {
          grid-row: 2 / span 1;
          grid-column: 2 / span 1;
        }

        .subquadrant-b {
          grid-row: 3 / span 1;
          grid-column: 1 / span 2;
        }
      }

      .quadrant-bl {
        grid-column: 1 / span 1;
        grid-row: 4 / span 2;
      }

      .quadrant-br {
        grid-column: 2 / span 1;
        grid-row: 4 / span 2;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/int_hcAboutMemorable.vue